import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingState } from '../LoadingState';
import { ThemeToggle } from '../ThemeToggle';
import { BreadcrumbProvider, BreadcrumbTrail } from './Breadcrumbs';
import { Sidebar } from './Sidebar';

/**
 * Port of Pages/Shared/_Layout.cshtml: fixed sidebar, sticky topbar with breadcrumbs,
 * scrolling page content and the copyright footer.
 */
export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <BreadcrumbProvider>
      <div className="layout-wrapper">
        <Sidebar show={sidebarOpen} onNavigate={() => setSidebarOpen(false)} />

        <div className="main-content">
          <header className="topbar">
            <div className="d-flex align-items-center gap-3">
              <button
                type="button"
                className="btn btn-link text-body d-lg-none p-0"
                onClick={() => setSidebarOpen((open) => !open)}
                aria-label="Toggle navigation"
              >
                <i className="bi bi-list" style={{ fontSize: '1.5rem' }} />
              </button>
              <BreadcrumbTrail />
            </div>

            {/* The search box and the notification bell (with a hardcoded "3") were template
                placeholders wired to nothing, and were removed from both portals. */}
            <div className="d-flex align-items-center gap-3">
              <ThemeToggle />
            </div>
          </header>

          <main className="page-content">
            <Suspense fallback={<LoadingState />}>
              <Outlet />
            </Suspense>
          </main>

          <footer className="border-top py-3 px-4">
            <small className="text-body-secondary">
              &copy; {new Date().getFullYear()} InertiaID. All rights reserved.
            </small>
          </footer>
        </div>
      </div>
    </BreadcrumbProvider>
  );
}
